import React from 'react';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { lightTheme } from './themes';
import SortRoute from './pages/SortRoute';
import Page404 from './pages/Page404';

const App = () => (
  <MuiThemeProvider theme={lightTheme}>
    <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'top' }} autoHideDuration={3000}>
      <React.Fragment>
        <CssBaseline/>
        <Router>
          <Switch>
            <Route path="/sortRoute/:uid/:code" component={SortRoute}/>
            <Route component={Page404}/>
          </Switch>
        </Router>
      </React.Fragment>
    </SnackbarProvider>
  </MuiThemeProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js